:host {
  display: block;
  position: absolute;
  z-index: 1;
}

.lilu-image-product-link {
  font-family: var(--font-family-averta);
  max-width: 250px;
}

.lilu-image-product-link-details {
  padding: 10px;
  border-radius: 18px;
  background-color: var(--color-white);
  display: inline-block;
  z-index: 1;
}

lilu-price + lilu-price {
  margin-top: 6px;
  display: inline-block;

  & + lilu-button {
    margin-top: 4px;
  }

  @include breakpointMin('sm') {
    margin-top: 0;
    display: inline;
    & + lilu-button {
      margin-top: 10px;
    }
  }
}

.lilu-image-product-link-title-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: var(--color-nero);
  padding-bottom: 2px;

  &:hover {
    .lilu-image-product-link-title {
      text-decoration: underline;
    }
  }
}

.lilu-image-product-link-title {
  display: block;
  font-weight: 600;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.lilu-image-product-link-title,
.lilu-image-product-link-price-old {
  font-size: 18px;
}

lilu-button {
  margin-top: 10px;
}
